import { FileDown } from "lucide-react";
import "./index.css";



// export default function FinancialInfo() {
//   return (
//     <div className="financial-container">
//       <main className="main-content">
//         <h1 className="page-title">Financial Information</h1>

//         <div className="financial-grid">
//           {/* Primary Tabs */}
//           <div className="tabs primary-tabs">
//             <button className="tab active">LCB</button>
//             <button className="tab">Accounts</button>
//           </div>

//           {/* Secondary Tabs */}
//           <div className="tabs secondary-tabs">
//             <button className="tab active">Quarterly</button>
//             <button className="tab">Half-Yearly</button>
//             <button className="tab">Manual</button>
//           </div>
//           {financialDocuments.map((doc) => (
//             <div key={doc.id} className="financial-card">
//               <div className="card-content">
//                 <h2 className="document-title">{doc.title}</h2>
//                 <p className="document-subtitle">{doc.subtitle}</p>
//                 <p className="document-date">{doc.date}</p>
//                 <a
//                   href={doc.downloadUrl}
//                   target="_blank"
//                   rel="noreferrer"
//                   className="download-button"
//                 >
//                   <span className="download-icon">
//                     <FileDown size={24} />
//                   </span>
//                   <span className="download-text">DOWNLOAD FILE</span>
//                   <span className="pdf-icon">PDF</span>
//                 </a>
//               </div>
//             </div>
//           ))}
//         </div>
//       </main>
//     </div>
//   );
// }



import React, { useState } from "react";
import "./index.css"; // Make sure to link the CSS file

export default function FinancialInfo() {
  const [activeCategory, setActiveCategory] = useState("lcb"); // 'lcb' or 'financial'
  const [activePeriod, setActivePeriod] = useState("quarterly"); // 'quarterly', 'half-yearly', 'yearly'


  // Filter Logic
  const filteredDocuments = financialDocuments.filter((doc) => {
    const matchCategory = doc.category === activeCategory;
    const matchPeriod = doc.period === activePeriod;
    return matchCategory && matchPeriod;
  });

  return (
    <div className="financial-container">
      <main className="main-content">
        <h1 className="page-title">Financial Information</h1>

        {/* --- LEVEL 1 TABS: Category --- */}
        <div className="tabs-main">
          <button
            className={`tab-btn sub ${activeCategory === "financial" ? "active" : ""}`}
            onClick={() => {
              setActiveCategory("financial");
              // setActivePeriod("half-yearly"); // Default to half-yearly for Accounts
            }}
          >
            Financial Statements
          </button>
          <button
            className={`tab-btn sub ${activeCategory === "lcb" ? "active" : ""}`}
            onClick={() => {
              setActiveCategory("lcb");
               setActivePeriod("quarterly"); // Default to yearly for LCB
            }}
          >
            Liquid Capital Balance (LCB)
          </button>

        </div>

{/* --- LEVEL 2 TABS: Period (Dynamic) --- */}
        <div className="tabs-sub">
          {activeCategory === "financial" ? (
            /* Show these buttons only for FINANCIAL */
            <>
              <button
                className={`tab-btn sub ${activePeriod === "half-yearly" ? "active" : ""}`}
                onClick={() => setActivePeriod("half-yearly")}
              >
                Half-Yearly
              </button>
              <button
                className={`tab-btn sub ${activePeriod === "yearly" ? "active" : ""}`}
                onClick={() => setActivePeriod("yearly")}
              >
                Yearly
              </button>
            </>
          ) : (
            /* Show these buttons only for LCB */
            <>
              <button
                className={`tab-btn sub ${activePeriod === "quarterly" ? "active" : ""}`}
                onClick={() => setActivePeriod("quarterly")}
              >
                Monthly
              </button>
              <button
                className={`tab-btn sub ${activePeriod === "yearly" ? "active" : ""}`}
                onClick={() => setActivePeriod("yearly")}
              >
                Annually
              </button>
            </>
          )}
        </div>

        {/* --- GRID --- */}
        <div className="financial-grid">
          {filteredDocuments.length > 0 ? (
            filteredDocuments.map((doc) => (
              <div key={doc.id} className="financial-card">
                <div className="card-content">
                  <h2 className="document-title">{doc.title}</h2>
                  <p className="document-subtitle">{doc.subtitle}</p>
                  <p className="document-date">{doc.date}</p>
                  <a
                    href={doc.downloadUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="download-button"
                  >
                    <span className="download-icon">
                      <FileDown size={24} />
                    </span>
                    <span className="download-text">DOWNLOAD FILE</span>
                    <span className="pdf-icon">PDF</span>
                  </a>
                </div>
              </div>
            ))
          ) : (
            <div>
              {/* <p>No documents found for this category.</p> */}
            </div>
          )}
        </div>
      </main>
    </div>
  );
}

const financialDocuments = 
[
  //  ------------------ LCB ---------------------------- //
  

  {
    id: "lcb-12-25",
    category: "lcb",
    period: "quarterly",
    title: "STATEMENT OF LCB NEW Am",
    subtitle: "LIQUID CAPITAL",
    date: "DEC 2025",
    downloadUrl: "/img/LCB DEC 2025.pdf",
  },

    {
    id: "lcb-11-25",
    category: "lcb",
    period: "quarterly",
    title: "STATEMENT OF LCB NEW Am",
    subtitle: "LIQUID CAPITAL",
    date: "NOV 2025",
    downloadUrl: "/img/LCB NOV 2025.pdf",
  },
    {
    id: "lcb-10-25",
    category: "lcb",
    period: "quarterly",
    title: "STATEMENT OF LCB NEW Am",
    subtitle: "LIQUID CAPITAL",
    date: "OCT 2025",
    downloadUrl: "/img/LCB OCT 2025.pdf",
  },
  {
    id: "lcb-9-25",
    category: "lcb",
    period: "quarterly",
    title: "STATEMENT OF LCB NEW Am",
    subtitle: "LIQUID CAPITAL",
    date: "SEP 2025",
    downloadUrl: "/img/LCB SEP 2025.pdf",
  },
  {
    id: "lcb-8-25",
    category: "lcb",
    period: "quarterly",
    title: "STATEMENT OF LCB NEW Am",
    subtitle: "LIQUID CAPITAL",
    date: "AUG 2025",
    downloadUrl: "/img/LCB AUG 2025.pdf",
  },


  {
    id: "lcb-7-25",
    category: "lcb",
    period: "quarterly",
    title: "STATEMENT OF LCB NEW Am",
    subtitle: "LIQUID CAPITAL",
    date: "JULY 2025",
    downloadUrl: "/img/LCB JULY 2025.pdf",
  },
  {
    id: "lcb-2",
    category: "lcb",
    period: "quarterly",
    title: "STATEMENT OF LCB",
    subtitle: "LIQUID CAPITAL",
    date: "JUNE 2025",
    downloadUrl: "/img/LCB JUNE 2025.pdf",
  },
  {
    id: "lcb-3",
    category: "lcb",
    period: "quarterly",
    title: "STATEMENT OF LCB",
    subtitle: "LIQUID CAPITAL",
    date: "MAY 2025",
    downloadUrl: "/img/LCB MAY 2025.pdf",
  },
  {
    id: "lcb-4",
    category: "lcb",
    period: "quarterly",
    title: "STATEMENT OF LCB",
    subtitle: "LIQUID CAPITAL",
    date: "APR 2024",
    downloadUrl: "/img/LCB APR 2025.pdf",
  },
  {
    id: "lcb-5",
    category: "lcb",
    period: "quarterly",
    title: "STATEMENT OF LCB",
    subtitle: "LIQUID CAPITAL",
    date: "MAR 2024",
    downloadUrl: "/img/LCB MAR 2025.pdf",
  },
  {
    id: "lcb-6",
    category: "lcb",
    period: "quarterly",
    title: "STATEMENT OF LCB",
    subtitle: "LIQUID CAPITAL",
    date: "FEB 2024",
    downloadUrl: "/img/LCB FEB 2025.pdf",
  },
  {
    id: "lcb-7",
    category: "lcb",
    period: "quarterly",
    title: "STATEMENT OF LCB",
    subtitle: "LIQUID CAPITAL",
    date: "JAN 2024",
    downloadUrl: "/img/LCB JAN 2025.pdf",
  },
  {
    id: "lcb-8",
    category: "lcb",
    period: "quarterly",
    title: "STATEMENT OF LCB",
    subtitle: "LIQUID CAPITAL",
    date: "FEBRUARY 2024",
    downloadUrl: "/img/LCS-FEBRUARY-REPORT-2024.pdf",
  },
  {
    id: "lcb-9",
    category: "lcb",
    period: "quarterly",
    title: "STATEMENT OF LCB",
    subtitle: "LIQUID CAPITAL",
    date: "MARCH 2024",
    downloadUrl: "/img/LCS-MARCH-REPORT-2024.pdf",
  },
  {
    id: "lcb-10",
    category: "lcb",
    period: "quarterly",
    title: "STATEMENT OF LCB",
    subtitle: "LIQUID CAPITAL",
    date: "APRIL 2024",
    downloadUrl: "/img/LCS-APRIL-REPORT-2024.pdf",
  },
  {
    id: "lcb-11",
    category: "lcb",
    period: "quarterly",
    title: "STATEMENT OF LCB",
    subtitle: "LIQUID CAPITAL",
    date: "MAY 2024",
    downloadUrl: "/img/LCS-MAY-REPORT-2024.pdf",
  },
  {
    id: "lcb-12",
    category: "lcb",
    period: "quarterly",
    title: "STATEMENT OF LCB",
    subtitle: "LIQUID CAPITAL",
    date: "JUNE 2024",
    downloadUrl: "/img/LCS-JUNE-REPORT-2024.pdf",
  },

  {
    id: "lcb-13",
    category: "lcb",
    period: "quarterly",
    title: "STATEMENT OF LCB",
    subtitle: "LIQUID CAPITAL",
    date: "AUGUST 2024",
    downloadUrl: "/img/LCS-AUGUST-REPORT-2024.pdf",
  },
  {
    id: "lcb-14",
    category: "lcb",
    period: "quarterly",
    title: "STATEMENT OF LCB",
    subtitle: "LIQUID CAPITAL",
    date: "SEPTEMBER 2024",
    downloadUrl: "/img/LCS-SEPTEMBER-REPORT-2024.pdf",
  },
  {
    id: "lcb-15",
    category: "lcb",
    period: "quarterly",
    title: "STATEMENT OF LCB",
    subtitle: "LIQUID CAPITAL",
    date: "OCTOBER 2024",
    downloadUrl: "/img/LCS-OCTOBER-REPORT-2024.pdf",
  },
  {
    id: "lcb-16",
    category: "lcb",
    period: "quarterly",
    title: "STATEMENT OF LCB",
    subtitle: "LIQUID CAPITAL",
    date: "NOVEMBER 2024",
    downloadUrl: "/img/LCS-NOVEMBER-REPORT-2024.pdf",
  },
  {
    id: "lcb-17",
    category: "lcb",
    period: "yearly",
    title: "STATEMENT OF LCB",
    subtitle: "LIQUID CAPITAL",
    date: "DECEMBER 2024",
    downloadUrl: "/img/LCS-DECEMBER-REPORT-2024.pdf",
  },
  {
    id: "lcb-18",
    category: "lcb",
    period: "quarterly",
    subtitle: "FINANCIAL STATEMENTS",
    title: " STATEMENT OF FINANCIAL",
    date: "30 June 2023",
    downloadUrl: "/img/FS-FOR-WEBSTIE-JUNE-2023-2.pdf",
  },
  {
    id: "lcb-19",
    category: "lcb",
    period: "yearly",
    subtitle: "FINANCIAL STATEMENTS",
    title: " STATEMENT OF FINANCIAL",
    date: "30 June 2022",
    downloadUrl:
      "/img/AUDITED-FINANCIAL-STATEMENTS-FOR-THE-YEAR-ENDED-JUNE-30-2022.pdf",
  },

  {
    id: "lcb-20",
    category: "lcb",
    period: "yearly",
    subtitle: "LIQUID CAPITAL",
    title: " STATEMENT OF LCB",
    date: "31 Dec 2023",
    downloadUrl: "/img/ALCB1223.pdf",
  },

  {
    id: "lcb-21",
    category: "lcb",
    period: "quarterly",
    subtitle: "LIQUID CAPITAL",
    title: " STATEMENT OF LCB",
    date: "22 June 2022",
    downloadUrl: "/img/AUDITED-STATEMENT-OF-NCB-AS-AT-JUNE-222022.pdf",
  },
  {
    id: "lcb-22",
    category: "lcb",
    period: "quarterly",
    subtitle: "LIQUID CAPITAL",
    title: " STATEMENT OF LCB",
    date: "15 Nov 2022",
    downloadUrl:
      "/img/AUDITED-STATEMENT-OF-LIQUID-CAPITAL-AS-AT-NOV-15-2022.pdf",
  },
  {
    id: "lcb-23",
    category: "lcb",
    period: "quarterly",
    subtitle: "STATEMENT OF NCB",
    title: " STATEMENT OF NCB",
    date: "15 Nov 2022",
    downloadUrl: "/img/AUDITED-STATEMENT-OF-NCB-AS-AT-JUNE-222022.pdf",
  },
  {
    id: "lcb-24",
    category: "lcb",
    period: "quarterly",
    subtitle: "FINANCIAL STATEMENTS",
    title: "AUDITED FINANCIAL",
    date: "22 June 2022",
    downloadUrl: "/img/31-DEC-FINANCIAL-STATMENT-2022-1.pdf",
  },
  {
    id: "lcb-25",
    category: "lcb",
    period: "quarterly",
    subtitle: "LIQUID CAPITAL",
    title: " STATEMENT OF LCB",
    date: "30 June 2022",
    downloadUrl:
      "/img/AUDITED-STATEMENT-OF-LIQUID-CAPITAL-AS-AT-JUNE-302022-2pdf",
  },
  {
    id: "lcb-26",
    category: "lcb",
    period: "quarterly",
    subtitle: "LIQUID CAPITAL",
    title: " STATEMENT OF LCB",
    date: "30 June 2023",
    downloadUrl: "/img/LIQUID-CAPITAL-JUNE-2023.pdf",
  },
  {
    id: "lcb-27",
    category: "lcb",
    period: "quarterly",
    title: "STATEMENT OF LCB",
    subtitle: "LIQUID CAPITAL",
    date: "JULY 2024",
    downloadUrl: "/img/LCS-JULY-REPORT-2024.pdf",
  },
  {
    id: "lcb-28",
    category: "lcb",
    period: "quarterly",
    title: "STATEMENT OF LCB",
    subtitle: "LIQUID CAPITAL",
    date: "January 2024",
    downloadUrl: "/img/LCS-JANUARY-REPORT-2024.pdf",
  },
  //  ------------------ FINANACIALS ---------------------------- //
 
   {
    id: "financial-2025",
    category: "financial",
    period: "yearly",
    title: "STATEMENT OF FINANCIAL",
    subtitle: "FINANCIAL STATEMENTS 2025",
    date: "30 June 2025",
    downloadUrl: "/img/Financial 30-june-2025.pdf",
  },
  {
    id: "financial-1",
    category: "financial",
    period: "half-yearly",
    title: "STATEMENT OF FINANCIAL",
    subtitle: "FINANCIAL STATEMENTS HALF 2024",
    date: "31 DEC 2024",
    downloadUrl: "/img/Financial Statement Half Yearly 31 DEC 2024.pdf",
  },
  {
    id: "financial-2",
    category: "financial",
    period: "yearly",
    title: "STATEMENT OF FINANCIAL",
    subtitle: "FINANCIAL STATEMENTS 2024",
    date: "30 June 2024",
    downloadUrl: "/img/FINANCIAL-STATEMENTS-NO-2.pdf",
  },

];
